import { Instance } from 'mobx-state-tree';
import { CreateServiceAccountDtoModelBase } from './CreateServiceAccountDtoModel.base';

/* The TypeScript type of an instance of CreateServiceAccountDtoModel */
export interface CreateServiceAccountDtoModelType extends Instance<typeof CreateServiceAccountDtoModel.Type> {}

/* A graphql query fragment builders for CreateServiceAccountDtoModel */
export { selectFromCreateServiceAccountDto, createServiceAccountDtoModelPrimitives, CreateServiceAccountDtoModelSelector } from './CreateServiceAccountDtoModel.base';

/**
 * CreateServiceAccountDtoModel
 */
export const CreateServiceAccountDtoModel = CreateServiceAccountDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
